import React, { useEffect, useState } from "react";
import { BarChart } from "@mui/x-charts";
import Typography from "@mui/material/Typography";
import { Get } from "../../Common/WebRequest";
import { Paper } from "@mui/material";
import "./TopStats.css";
const TopTeachers = () => {
  const [loading, setLoading] = useState(true);
  const [topTeachers, setTopTeachers] = useState([]);

  useEffect(() => {
    (async () => {
      try {
        const res = await Get("Statistics/TopTeachers");

        if (res.isSuccess) {
          const data = res.result;

          setTopTeachers(data);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!topTeachers || topTeachers.length === 0) {
    return <div></div>;
  }

  return (
    <Paper elevation={3} className="top-container">
      <Typography align="left" variant="h6" gutterBottom>
        Top Lehrkräfte
      </Typography>
      <div className="chart-container">
        <BarChart
          xAxis={[
            {
              scaleType: "band",
              data: topTeachers.map((item) => item.teacherName),
            },
          ]}
          yAxis={[{ id: "linearAxis", scaleType: "linear" }]}
          series={[
            {
              yAxisKey: "linearAxis",
              data: topTeachers.map((item) =>
                !isNaN(item.numberOfCourses) ? item.numberOfCourses : 0
              ),
              label: "Fächer",
              color: "#27aeef",
            },
            {
              yAxisKey: "linearAxis",
              data: topTeachers.map((item) =>
                !isNaN(item.numberOfStudents) ? item.numberOfStudents : 0
              ),
              label: "Schüler",
              color: "#b04238",
            },
          ]}
          leftAxis="linearAxis"
          height={250}
        />
      </div>
    </Paper>
  );
};

export default TopTeachers;
